import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import { communicationColumns } from "./AllCiolumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useFetchPasswords from "../../hooks/useFetchPasswords";
import useChangeHandler from "../../hooks/useChangeHandler";
import * as Style from "../../../../../newComponents/styledComponents/PersonalInstruction";
import deathApi from "../../../../../apis/death.api";
import { Modal } from "antd";
import swal from "sweetalert";

const MODULE_NAMES = ["Communication Plan", "Emergency Alert Subscriptions", "Backup Communication Devices"];
export default function CommunicationPlan(props) {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Communication Plan");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(true);
  const [listofPassword, setListofPassword] = useState([]);
  const [message, setMessage] = useState("");
  const history = useHistory();

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { attributes, disasterAttribute } = useGetAttributes(MODULE_NAMES, setLoading);
  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { passwordList } = useFetchPasswords();
  console.log("passwordList", passwordList);

  const AddContact = () => {
    history.push("/client/plan");
  };
  const communicationTables = [
    { title: "Out-of-state Contact Person", key: 1 },
    { title: "Social Media Accounts", key: 2 },
    { title: "Emergency Alert Subscriptions", key: 3 },
    { title: "Backup Communication Devices", key: 4 },
  ];
  const tableDataObj = {
    "Emergency Alert Subscriptions": tableData.emergencyAlertSubscriptionsData,
    "Backup Communication Devices": tableData.backupCommunicationDevicesData,
  };
  const AllColumnsData = communicationColumns(viewModal, updateModal, deleteRecord);

  const handleCancel = () => {
    setIsOtpModalVisible(false);
    // this.props.postSavedOtp("")
    localStorage.setItem("otp", "");
  };
  const handleOk = async () => {
    console.log("login......", formData);
    let message = {};
    let data = {};
    if (formData !== undefined) {
      // this.props.postSavedOtp(this.state.formData.otp)
      // localStorage.setItem("otp", formData.otp);
      // this.props.handleLoader();
      setLoading(true);

      try {
        const ID = localStorage.getItem("accessId");
        data = await deathApi.fetchPasswords(formData && formData.otp, ID);
        message = data;
        setMessage(data);
        // this.setState({ message: data })
        console.log("data passwordlist", data);
        if (data && data.status === 200) {
          console.log("formData.otp", formData);
          localStorage.setItem("otp", formData.otp);

          if (data && data.data) {
            setListofPassword(data.data);
          }
        }
        setLoading(false);
        if (formData.otp) {
          setIsOtpModalVisible(false);
        } else {
          swal("Oops!", "Invalid OTP", "error");
        }
      } catch (error) {
        console.log("here in catch", error);
      }
    }
    if (data.status === 400 && data.message === "Please enter a valid OTP") {
      swal("Oops!", "Please enter a valid OTP", "error");
      setIsOtpModalVisible(true);
    }
  };
  const cols = [
    {
      title: "Site/App/Program",
      dataIndex: "appName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "UserName",
      dataIndex: "userName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Password",
      dataIndex: "passwordFor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Password Hint",
      dataIndex: "passwordHint",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Website URL",
      dataIndex: "appUrl",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "2FA",
      dataIndex: "twoFactor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Pin",
      dataIndex: "pin",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Security Question",
      dataIndex: "securityQuestion",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Answer",
      dataIndex: "answer",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "note",
      render: (record) => (record ? record : "N/A"),
    },
  ];
  const getPasswordList = async () => {
    if (props.role == "protrustee") {
      isSecondPasswordGranted();
    }

    if (props.role !== "protrustee") {
      if (!localStorage.getItem("otp")) {
        localStorage.setItem("otp", "");
      }
      if (localStorage.getItem("otp") === "") {
        showModalOtp();
      } else {
        // this.props.handleLoader();
        setLoading(true);
        console.log("this.state.userData", formData);
        if (localStorage.getItem("otp")) {
          const ID = localStorage.getItem("accessId");

          let data = await deathApi.fetchPasswords(localStorage.getItem("otp"), ID);
          if (data.message === "This is an expired OTP") {
            showModalOtp();
          } else {
            if (data && data.data) {
              setListofPassword(data.data);
            }
          }
          setLoading(false);
          // this.props.handleLoader();
        }
      }
    }
  };
  const isSecondPasswordGranted = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await deathApi.getSecondPasswordStatus(ID);
      // this.props.handleLoader();
      setLoading(false);

      console.log("data.message", data.date.secondPasswordGranted);
      // this.setState({
      //   OTP_Status: data.date.secondPasswordGranted,
      // });
      if (data.date.secondPasswordGranted === 1) {
        if (!localStorage.getItem("otp")) {
          localStorage.setItem("otp", "");
        }
        if (localStorage.getItem("otp") === "") {
          showModal();
        } else {
          // this.props.handleLoader();
          setLoading(true);
          console.log("this.state.userData", formData);
          if (localStorage.getItem("otp")) {
            const ID = localStorage.getItem("accessId");

            let data = await deathApi.fetchPasswords(localStorage.getItem("otp"), ID);
            if (data.message === "This is an expired OTP") {
              showModal();
            } else {
              if (data && data.data) {
                setListofPassword(data.data);
              }
            }
            setLoading(false);
            // this.props.handleLoader();
          }
        }
      }

      if (data.date.secondPasswordGranted === 0) {
        setLoading(true);
        // this.props.handleLoader();
        swal("Restricted!", "You have not been granted access to this information.", "warning");
        setLoading(false);

        // this.props.handleLoader();
      }
    } catch (error) {
      console.log("e ", error);
    }
  };
  const showModalOtp = async () => {
    setIsOtpModalVisible(true);

    // this.setState({
    //   isModalOpen: true,
    // });
    // console.log("userData", this.state.userData);
    try {
      const ID = localStorage.getItem("accessId");

      let data = await deathApi.configOtp(ID);
      console.log("data>>", data);
      swal(data.message);
      // console.log("data.message",data.message)
    } catch (error) {
      console.log("e ", error);
    }
  };
  useEffect(() => {
    getPasswordList();
  }, []);
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <h2 className="parent-title">Communication Plan</h2>
        <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      {communicationTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => ([1, 2].includes(table.key) ? AddContact() : showModal(table.title))}
        >
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      <div className="parent-title-container">
        <h2 className="parent-title">Passwords</h2>
        <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      <CollapseableTable title={"All Passwords"} key={5} show={true}>
        <Table columns={cols} dataSource={listofPassword} />
      </CollapseableTable>
      <NewLoader isLoading={loading} />
      <Modal visible={isOtpModalVisible} footer={null} closable={false} centered>
        <div style={{ marginTop: "20px" }}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}> List of Passwords</h3>
          <div className="">
            <h2 className="otp-heading" style={{ color: "#4d5e80" }}>
              This passcode provides another layer of security for your list of passwords. The passcode is
              only valid for this session.
            </h2>
            <div>
              <Style.Input
                onChange={(e) => {
                  e.persist();
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    [e.target.name]: e.target.value,
                  }));
                }}
                id="otp"
                type="text"
                // pattern="[0-9]{10}"
                pattern="[0-9.]+"
                // pattern="[0-9]+"
                // pattern="\d*"
                // maxlength="4"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"
              />

              <Style.ResendButton
                onClick={async () => {
                  console.log();
                  const ID = localStorage.getItem("accessId");
                  setLoading(true);
                  let data = await deathApi.configOtp(ID);
                  console.log("data>>", data);
                  swal(data.message);
                  setLoading(false);
                }}
              >
                Resend OTP
              </Style.ResendButton>

              <Style.WrapperButtons>
                <Style.CancelButton
                  id="stop"
                  onClick={() => {
                    handleCancel();
                  }}
                >
                  Cancel
                </Style.CancelButton>
                <Style.SaveButton onClick={handleOk}>Done</Style.SaveButton>
              </Style.WrapperButtons>
            </div>
          </div>
        </div>
        {/* <Loader isLoading={loading} /> */}
      </Modal>
    </div>
  );
}
